const Index = () => import("@/page/index");

const HomeIndex = () => import('@/page/home/homeIndex');
const CCHomeIndex = () => import('@/page/home/ccHomeIndex');
const HomeAbout = () => import('@/page/home/homeAbout');
const newsDetail = () => import('@/page/home/newsDetail');
const modular = () => import('@/page/home/modular');
const CloudPaper = () => import('@/page/home/cloudpaper');


export default {
  path:'/index',
  component:Index,
  children:[ {
      path: 'homeindex',
      name: 'HomeIndex',
      component:HomeIndex,
    },{
      path: 'cchomeindex',
      name: 'CCHomeIndex',
      component:CCHomeIndex,
    },{
      path: 'homeabout',
      name: 'HomeAbout',
      component:HomeAbout,
    },{
      path: 'newsdetail',
      name: 'newsDetail',
      component:newsDetail,
    },{
      path: 'modular',
      name: 'modular',
      component:modular,
    },{
      path: 'cloudpaper',
      name: 'cloudPaper',
      component:CloudPaper,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/homeindex.js